module.exports = __webpack_public_path__ + "img/sliders-00.eeccf48b.jpg";